module.exports = __webpack_public_path__ + "img/9808898.jpg";